<template>
  <div id="appFooter">
    <div class="m-bottom">
      <div class="tips">
        <p>长按保存图片识别二维码</p>
        <p>关注天泰商旅公众号</p>
      </div>
      <div class="tt-mt10 tt-mb10">
        <img class="code-img" src="~@img/tt-er.jpg" alt="" />
      </div>
      <div class="copyright">
        <a
          target="_blank"
          class="tt-orange tt-link"
          href="https://beian.miit.gov.cn"
          >粤ICP备17035665号
        </a>
        <br />
        Copyright©2019 深圳市天泰网络技术有限公司 版权所有.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'appFooter',
  data () {
    return {}
  },
  created () {
    this.loadData()
  },
  methods: {
    // 加载基础数据
    async loadData () {}
  }
}
</script>
<style lang="less" scoped>
.m-bottom {
  background-color: #171c26;
  color: #fff;
  padding: 20px 0;
  text-align: center;
  .code-img {
    width: 120px;
    height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue